export const KEYCODES = {
  TAB: 9,
  ESC: 27,
  SPACE: 32,
  ENTER: 13,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
};

/**
 * @param event -  Should be React Keyboard Event
 * @description check handle 'Enter' and 'space' keys
 */
export const isEnterOrSpace = (event) => {
  if (event && event.nativeEvent instanceof KeyboardEvent) {
    const { keyCode, charCode } = event;
    if (keyCode === KEYCODES.ENTER || keyCode === KEYCODES.SPACE || charCode === KEYCODES.ENTER || charCode === KEYCODES.SPACE) {
      return true;
    }
  }
  return false;
};
